import { makeStyles, TextField } from "@material-ui/core";
import { useFormik } from "formik";
import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { DEAFAULT_PAGESIZE, setPayloadForFetchSoundLists } from "..";
import { Loader2 } from "../../../../../../util/loading";
import { actions } from "../../../../../Dashboard/_redux/dashboardRedux";
import {
  fetchTTSSoundsLists,
  postUploadedUserSound,
  setCurrentPage,
  setSoundListingApiPayload,
  updateUserSound,
  uploadSound,
} from "../../../../state/slices/soundsSlice";
import BrowseSoundFile from "./BrowseSoundFile";
import SaveSoundAndCancel from "./SaveSoundAndCancel";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    marginRight: theme.spacing(4),
    marginLeft: theme.spacing(2),
    display: "flex",
    minWidth: 120,
  },

  root: {
    "& .MuiOutlinedInput-input": {
      borderRadius: "4px",
      backgroundColor: "#f3f6f9",
    },

    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
    },

    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "purple",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "purple",
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: "purple",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "purple",
    },
    "& .MuiOutlinedInput-multiline": {
      backgroundColor: "#f3f6f9",
    },
  },

  highLightText: {
    color: "#892193",
    fontSize: "14px",
    cursor: "pointer",
    "&:hover": {
      color: "#892193",
    },
  },

  secondaryLabel: {
    color: "#9d9db1",
    fontSize: "12px",
    fontWeight: 500,
  },

  title: {
    fontSize: "12px",
    fontWeight: 500,
    color: "#000",
  },
  textField: {
    backgroundColor: "#f3f6f9",
  },
}));

const RecordedUploadSound = ({
  handleCloseUploadSounds,
  editSound = false,
  soundObj = null,
  setToastValue,
}) => {
  const classes = useStyles();
  const { soundlibobj } = soundObj || false;

  const { activeSoundTab, pageSize, searchQuery, currentPage } = useSelector(
    (state) => state.soundsSlice
  );

  const dispatch = useDispatch();

  const soundFileSchema = !editSound
    ? {
        soundFile: Yup.mixed()
          .required("Please choose a sound file.")
          .test(
            "fileSize",
            "The total file(s) size exceeding the max size limit of 10MB",
            (value) => {
              if (!value) return true;
              let filesSize = 0;
              if (value && value?.length > 0) {
                for (let i = 0; i < value.length; i++) {
                  filesSize += value[i].size;
                }
                if (filesSize > 10485760) {
                  return false;
                }
              }
              return true;
            }
          )
          .test(
            "FILE_FORMAT",
            `Invalid type file. Only '.mp3 or .wav' files are supported.`,
            (value) => {
              if (!value) return true;
              if (value && value?.length > 0) {
                for (let i = 0; i < value.length; i++) {
                  if (!["audio/mpeg", "audio/wav"].includes(value[i].type)) {
                    return false;
                  }
                }
              }
              return true;
            }
          )
          .test(
            "fileCount",
            "Too many files selected. Please select up to 10 files.",
            (value) => {
              if (!value) return true;
              if (value && value?.length > 10) {
                return false;
              }
              return true;
            }
          ),
      }
    : {};
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      soundName: editSound ? soundlibobj?.soundname : "",
      language: editSound ? soundlibobj?.language : "",
      ...(!editSound && { soundFile: "" }),
      description: editSound ? soundlibobj?.description : "",
    },
    validationSchema: Yup.object().shape(
      {
        soundName: Yup.string()
          .required("Please enter Sound name.")
          .min(1)
          .matches(
            /^[a-zA-Z0-9-_ ]+$/i,
            "The sound name should not contain any special characters apart from hyphen (-) & underscore (_)."
          )
          .max(
            30,
            "Sound Name can hold up to 30 Characters. Please remove some characters."
          ),
        language: Yup.string()
          .notRequired("Please enter Language.")
          .matches(
            /^[a-z0-9]+$/i,
            "The Language should not contain any special characters."
          )
          .min(1),
        ...soundFileSchema,
        description: Yup.string()
          .nullable()
          .notRequired()
          .max(
                500,
                "Description can accept up to 500 Characters. Please remove some characters."
              ),
      }
    ),
    onSubmit: (values, { resetForm }) => {
      dispatch(
        actions.setLoadingState({
          resource: "upload_sound",
          loading_state: "loading",
        })
      );

      if (editSound) {
        const editSoundObj = JSON.parse(JSON.stringify(soundObj));
        const { soundlibobj } = editSoundObj;
        soundlibobj.language = values.language;
        soundlibobj.description = values.description;
        soundlibobj.soundname = values.soundName;

        dispatch(updateUserSound(editSoundObj)).then((response) => {
          if (response.error) {
            const { payload } = response;
            setToastValue(true, payload.error, "error");
          } else {
            setToastValue(true, "Sound updated successfully", "success");
            dispatch(
              actions.setLoadingState({
                resource: "sound_lists",
                loading_state: "loading",
              })
            );
            setTimeout(() => {
              let payload = setPayloadForFetchSoundLists(
                currentPage,
                pageSize,
                activeSoundTab
              );
              payload = {
                ...payload,
                ...(searchQuery && {
                  soundlibobj__soundname__icontains: searchQuery,
                }),
              };
              dispatch(fetchTTSSoundsLists(payload));
            }, 1000);
          }
          closeUploadSoundDialog();
        });
      } else {
        let assumeId = localStorage.getItem("assume_id");
        assumeId = (assumeId === 'null' || assumeId === '' || assumeId === 'None') ? false : assumeId;
        const formData = new FormData();
        formData.append("soundname", values.soundName);
        formData.append("soundfile", values.soundFile[0]);
        formData.append("language", values.language);
        formData.append("description", values.description);
        formData.append("status", assumeId ? "1" : "0");
        dispatch(uploadSound(formData)).then((response) => {
          if (response.error) {
            const { payload } = response;
            setToastValue(true, payload.error, "error");
          } else {
            const {
              payload: {
                data: { id, msg },
              },
            } = response;
            setToastValue(true, msg[0], "success");
            dispatch(
              postUploadedUserSound({
                soundlibobj_id: id,
                type: "LIb",
              })
            );
            setTimeout(() => {
              let payload = setPayloadForFetchSoundLists(
                1,
                pageSize,
                activeSoundTab
              );
              payload = {
                ...payload,
                ...(searchQuery && {
                  soundlibobj__soundname__icontains: searchQuery,
                }),
              };
              if (currentPage > 1) {
                dispatch(setSoundListingApiPayload(payload));
                dispatch(setCurrentPage(1));
              } else {
                dispatch(fetchTTSSoundsLists(payload));
              }
            }, 800);
          }
          closeUploadSoundDialog();
        });
      }
    },
  });

  const closeUploadSoundDialog = () => {
    formik.resetForm();
    handleCloseUploadSounds();
  };

  return (
    <div>
      <form className="form" onSubmit={formik.handleSubmit}>
        <Loader2 resource="upload_sound" />
        <div className="w-100  pr-10">
          <div>
            <div className="mt-2 ml-5">
              <TextField
                id="soundName"
                name="soundName"
                className={classes.root}
                autoComplete="off"
                autoFocus={false}
                variant="outlined"
                label="Enter Sound Name"
                margin="dense"
                fullWidth
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.soundName}
              />

              {formik.touched.soundName && formik.errors.soundName && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.soundName}</div>
                </div>
              )}
            </div>

            <div className="mt-2 ml-5">
              <TextField
                id="language"
                name="language"
                className={classes.root}
                autoComplete="off"
                autoFocus={false}
                variant="outlined"
                label="Enter Language"
                margin="dense"
                fullWidth
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.language}
              />
              {formik.touched.language && formik.errors.language && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.language}</div>
                </div>
              )}
            </div>

            <div className="mt-2 ml-5">
              <TextField
                id="description"
                name="description"
                multiline
                className={classes.root}
                rows={10}
                autoComplete="off"
                variant="outlined"
                label="Enter Description"
                margin="dense"
                value={formik.values.description}
                fullWidth
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.description && formik.errors.description && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">
                    {formik.errors.description}
                  </div>
                </div>
              )}
              <div className="d-flex justify-content-between pt-2">
                <div>
                  <span>
                    <strong>
                      Characters Left:{" "}
                      {formik.values.description.length > 500
                        ? 0
                        : 500 - formik.values.description.length}
                    </strong>
                  </span>
                </div>
              </div>
            </div>
            {!editSound && (
              <BrowseSoundFile uploadMultiple={false} formikValue={formik} />
            )}
          </div>

          <SaveSoundAndCancel
            handleCloseUploadSounds={closeUploadSoundDialog}
          />
        </div>
      </form>
    </div>
  );
};

export default memo(
  RecordedUploadSound,
  (prevProps, nextProps) => prevProps !== nextProps
);
